const WEBTRAC_FMID_RE = /(?:\?|&)FMID=(\d+)(?:&|$)/i;

export function extractWebtracFmidFromUrl(url: unknown): string | null {
  const s = String(url ?? "").trim();
  if (!s) return null;
  const m = s.match(WEBTRAC_FMID_RE);
  return m?.[1] ? String(m[1]) : null;
}

export function buildTier0SourceKeyFromUrl(url: unknown): string | null {
  const fmid = extractWebtracFmidFromUrl(url);
  if (!fmid) return null;
  return `webtrac:fmid:${fmid}`;
}

export function normalizeUrlForKey(url: unknown): string {
  return String(url ?? "").trim();
}

export function isoDayUtc(d: Date): string {
  // YYYY-MM-DD in UTC
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function numDaysFromDatesUtcInclusive(start: Date, end: Date): number {
  const s = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
  const e = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
  const msPerDay = 24 * 60 * 60 * 1000;
  const diff = Math.round((e - s) / msPerDay);
  return 1 + Math.max(0, diff);
}

export function buildTier1IdempotencyKey(input: {
  locationId: unknown;
  offeringId: unknown;
  startDate: unknown;
  endDate: unknown;
  numDays: unknown;
  url: unknown;
}): string | null {
  const locationId = String(input.locationId ?? "").trim();
  const offeringId = String(input.offeringId ?? "").trim();
  const url = normalizeUrlForKey(input.url);
  const start = input.startDate instanceof Date ? input.startDate : null;
  const end = input.endDate instanceof Date ? input.endDate : null;
  const numDays = Number(input.numDays);

  if (!locationId || !offeringId || !url || !start || !end) return null;
  if (!Number.isFinite(numDays) || numDays <= 0) return null;

  return `${locationId}|${offeringId}|${isoDayUtc(start)}|${isoDayUtc(end)}|${Math.trunc(numDays)}|${url}`;
}

